import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo-win.svg";
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import { setPartiallyVerified } from "../../Redux/verificationReducer";
import { useDispatch } from "react-redux";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import ErrorModal from "../Security/ErrorModal";
import LanguageSelector from "../../Common/LanguageSelector";
import { useTranslation } from 'react-i18next';
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { set } from "date-fns";


const CompanyForm = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [company, setCompany] = useState("");
  const [healthPlanID, setHealthPlanID] = useState("");
  const [combinedCompanyData, setCombinedCompanyData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [companyErrorMessage, setCompanyErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [enrollLink, setEnrollLink] = useState("");
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const { currentStep = 5, totalSteps = 5 , combinedDataMemberId} = location.state || {};
  debugger
 const [isHealthPlanIDPresent, setIsHealthPlanIDPresent] = useState(false);
  const [logo, setLogo] = useState(null);
  const [showModalR7, setShowModalR7] = useState(false);
  const [loading, setLoading] = useState(false);
const dispatch = useDispatch();

  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);

  // Get the passed state (combinedFormData) from the previous component
  useEffect(() => {
    if (combinedDataMemberId) {
      setCombinedCompanyData(combinedDataMemberId || {});
      setCompany(combinedDataMemberId.Company || "");
    }
  }, [location.state]);

   // Handle form submission
   const handleSubmit = async (e) => {
    e.preventDefault();

     // Validate access code
     if (!company.trim()) {
      setCompanyErrorMessage("Please enter the company.");
      return;
    }

    if(isHealthPlanIDPresent && !healthPlanID.trim()) {
      setErrorMessage("Please enter the Health Plan ID Number."); 
      return;
    }

    // Add the access code to the combinedFormData's PromoCode field
    const updatedFormData = {
      ...combinedCompanyData,
      Company: company,
      HealthPlanId: healthPlanID,
    };
              // Prepare the _Params object
              const paramsObject = { ...updatedFormData,
                EmployeeID: "",
                EmployeeFirstName: "",
                EmployeeLastName: "",
                RelationshiptoEmployee: "" ,
                Contract:"",
                MemberID:""
              };

              // Log the updated data before API call
              console.log("Updated Form Data with Access Code:", updatedFormData);
setLoading(true);
              // Make the API call
              try {
                setIsSubmitting(true);
                const response = await axios.post(
                  Endpoints.CreateAccount,
                  null,
                  {
                    params: { _Params: JSON.stringify(paramsObject) },
                  }
                );
                // Handle the API response
                console.log("API Response:", response);
                if(response.data.isWIN === "Y"){
                  navigate("/contact-info");
                  return;
                }
                if(response.data.IsHealthIDPresent && !response.data.HealthPlanId){
                  setIsHealthPlanIDPresent(true);
                }
                else if (response.data.Result === 2) {
                  console.log("Form submitted successfully:", paramsObject);
                  
                  if(!isHighmarkPortal)
                  {
                    const isNavigatingFromCompany = true;
                    if (updatedFormData.Country != "United States of America") {
                      navigate("/patientconsent-form", { state: { updatedFormData: updatedFormData, responseData: response.data,isNavigatingFromCompany } });
                    }
                    else{
                      if(response.data.Message === "Partial account created"){
                        dispatch(setPartiallyVerified());
          
      debugger
      const mergedFormData = { 
                          ...updatedFormData, 
                          BabyCountFlag: response.data.BabyCountFlag 
                        };
                      navigate("/healthprofilesetup", {
                        state:{
                          updatedFormData:mergedFormData,
                          isNavigatingFromCompany
                        }
                      }); 
                    }
                    }
                  }
                  else {
                    dispatch(setPartiallyVerified());
                      const mergedFormData = { 
                          ...updatedFormData, 
                          BabyCountFlag: response.data.BabyCountFlag 
                        };
      debugger
                    navigate("/healthprofilesetup", {
                      state:
                      {
                        updatedFormData:mergedFormData

                      }
                    });

                  }
                } else if (response.data.Result === 8) {
                  console.log("Error or different result:", response.data.Message);
                  // Navigate to the company name route with the updated form data
                  setModalMessage(response.data.Message);
                  setEnrollLink(response.data.Link);
                  setShowModal(true);
                } else if (response.data.Result === 9){
                  debugger
                  console.log("Error or different result:", response.data.Message);
                  // Navigate to the company name route with the updated form data
                  navigate("/contracts", { state: {updatedFormData, apiResponse: response.data,} });
                }
                 else if (response.data.Result === 7){
                console.log("Error or different result:", response.data.Message);
                // Navigate to the company name route with the updated form data
                setModalMessage(response.data.Message);
                setShowModalR7(true);
                //navigate("/login")
              }
              else if (response.data.Result === 0){
                console.log("Error or different result:", response.data.Message);
                // Navigate to the company name route with the updated form data
                setModalMessage(response.data.Message || "An unexpected error occurred. Please try again.");
                setShowModal(true);
              }
              } catch (error) {
                console.error("API Error:", error);
                // Navigate to companyname with the updated form data on API error
                navigate("/companyname", { state: updatedFormData });
              } finally {
                setIsSubmitting(false);
                setLoading(false);
              }
              };

              const handleNoCompanyClick = () => {
                navigate("/contact", { state: combinedCompanyData });
              }
   // Handle access code change
   const handleCompanyChange = (e) => {
    const input = e.target.value.toUpperCase(); // Convert input to uppercase
    setCompany(input);
    setCompanyErrorMessage(""); // Clear error message when typing
  };
  // Handle health plan ID change
  const handleHealthPlanIDChange = (e) => {
    const input = e.target.value.toUpperCase(); 
    setHealthPlanID(input);
        setErrorMessage(""); // Clear error message when typing
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
  const handleBackClick = () => {
    if(!company.trim() || !healthPlanID.trim())
    { navigate("/accesscode", { state: combinedCompanyData  })}
    else
    {
      const finalData = {
        ...combinedCompanyData,   // keep everything from the object
        Company: company,         // add / override
        HealthPlanId: healthPlanID
      };
      navigate("/accesscode", { state: finalData });
    }
  };
const handleModalCloseForResult7 = () => {
  setShowModalR7(false);
  navigate("/login");
};

 if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }


  return (
    <>
    {/* <div> <LanguageSelector /></div> */}
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>

      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}

        {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
            
            <h3 className="page-heading-secondary-black">{t('companysponsors')}</h3>
            {/* <h3 className="page-heading-bold">Username</h3> */}
            <p>{t('companymsg')}</p>

            <div className="registration-process-form-wrapper mt-5">
              <form onSubmit={handleSubmit}>
                
                <div className="mb-3">
                  <label
                    htmlFor="phoneNumber"
                    className="form-label win-form-label"
                  >
                    {t('company')}
                  </label>
                  <input
                    type="text"
                    className="form-control win-form-control"
                    value={company}
                    onChange={handleCompanyChange}
                    required
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSubmit(e);
                      }
                    }}
                  />
                  {companyErrorMessage && <div className="form-field-error-message">{companyErrorMessage}</div>}
                </div>
                <div className="mt-3">
                  <span
                    onClick={handleNoCompanyClick}
                    className="text-primary-color ms-3"
                    style={{cursor: "pointer"}}
                  >
                    {t('dontcompany')}
                  </span>
                </div>
                <br />
                {isHealthPlanIDPresent && <div>
                  <p>{t('healthplanidmsg')}</p>
                  <br />
                  <div className="mb-3">
                    <label
                      htmlFor="healthplanid"
                      className="form-label win-form-label"
                    >
                      {t('healthplanid')}
                    </label>
                    <input
                      type="text"
                      className="form-control win-form-control"
                      value={healthPlanID}
                      onChange={handleHealthPlanIDChange}
                      required
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleSubmit(e);
                        }
                      }}
                    />
                    {errorMessage && <div className="form-field-error-message">{errorMessage}</div>}
                  </div>
                </div>}
                <div className="mb-3 mt-4">
                {isHighmarkPortal ? (
                        <>
                          <div className="pagination-wrapper mt-5">
                          <button className="previous-btn" onClick={handleBackClick} type="button"></button>
                          
                          <span className="step-counter me-3">
                            {currentStep} of {totalSteps}
                          </span>
                        
                          <button className="next-btn" onClick={handleSubmit} type="submit" disabled={isSubmitting}></button>
                          {/* <div className="step-progress-bar d-flex gap-2 mt-3">
                          {[...Array(totalSteps)].map((_, index) => (
                            <div
                              key={index}
                              className={`step-segment ${index < currentStep ? 'active' : ''}`}
                            />
                          ))}
                        </div> */}
                        </div>
                        </>
                      ) : (
                        <>
                  <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0"  onClick={handleBackClick}>{t('back')}</button>
                  <button className="win-btn-primary mobile-view" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  {isSubmitting ? t('nextbutton') : t('nextbutton')}
                   
                  </button>
                  </>
                      )}
                </div>
              </form>
            </div>

          </div>
        </div>
        {/* registration right form area end */}
        <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)}  enrollLink={enrollLink}/>
      <ErrorModal show={showModalR7} message={modalMessage} onClose={handleModalCloseForResult7} />
      </div>  
      <style>
      {`
    .step-progress-bar {
      display: flex;
      justify-content: center;
    }

    .step-segment {
      flex: 1;
      height: 8px;
      background-color: #e0e0e0;
      border-radius: 4px;
      transition: background-color 0.3s ease;
    }

    .step-segment.active {
      background-color: #0057a0;
    }

    .step-progress-bar .step-segment:not(:last-child) {
      margin-right: 8px;
    }
  `}
</style>      
    </>
  );
 
};
export default CompanyForm;

